export default __webpack_public_path__ + "img/77c0f201222f05ce825331ae7cc60c00.png";